import React from "react";

type PaginationButtonProps = {
    active?: boolean
    page: number
    onClick: () => void
}
const PaginationButton = ({active, onClick, page}: PaginationButtonProps) => {
    return (
        <li className={`page-item ${active ? 'active' : ''}`}>
            <button className="page-link" onClick={(e) => {
                e.preventDefault()
                onClick()
            }}>
                {page}
            </button>
        </li>
    )
}

type Props = {
    currentPage: number
    totalItems: number
    pageSize: number
    onPageChange?: (page: number) => void
    position: 'bottom' | 'top'
}

export function GridPaginationComponent({
                                            currentPage,
                                            totalItems,
                                            pageSize,
                                            onPageChange,
                                            position
                                        }: Props) {
    const totalPages = Math.ceil(totalItems / pageSize);

    if (totalPages < 2) {
        return (<></>)
    }

    const prevButtonDisabled = !currentPage
    const nextButtonDisabled = currentPage === (totalPages - 1)

    const prevButtonClick = () => {
        if (prevButtonDisabled || onPageChange == null) {
            return;
        }
        onPageChange(currentPage - 1)
    }

    const nextButtonClick = () => {
        if (nextButtonDisabled || onPageChange == null) {
            return;
        }
        onPageChange(currentPage + 1)
    }

    const buttons: React.ReactElement[] = []

    const offset = 4;

    if (totalPages > (offset * 2)) {
        let start = currentPage > offset ? currentPage - offset : 0
        let end = currentPage > offset ? currentPage + offset : (offset * 2)

        if ((currentPage + offset) > totalPages) {
            start = totalPages - (offset * 2)
            end = totalPages
        }

        if (start > 0) {
            buttons.push(
                <li className="page-item previous disabled pt-2" key={`${position}-button-dots-start`}>
                    <span className='text-muted'>...</span>
                </li>
            )
        }

        for (let i = start; i < end; i++) {
            buttons.push(
                <PaginationButton
                    key={`${position}-button-${i}`}
                    active={i === currentPage}
                    page={i + 1}
                    onClick={() => {
                        if (onPageChange != null) {
                            onPageChange(i)
                        }
                    }}
                />
            )
        }

        if (start > 0) {
            buttons.push(
                <li className="page-item previous disabled pt-2" key={`${position}-button-dots-end`}>
                    <span className='text-muted'>...</span>
                </li>
            )
        }
    } else {
        for (let i = 0; i < totalPages; i++) {
            buttons.push(
                <PaginationButton
                    key={`${position}-button-${i}`}
                    active={i === currentPage}
                    page={i + 1}
                    onClick={() => {
                        if (onPageChange != null) {
                            onPageChange(i)
                        }
                    }}
                />
            )
        }
    }

    return (
        <ul className="pagination py-4">
            <li className={`page-item previous ${prevButtonDisabled ? 'disabled' : ''}`}>
                <button className="page-link" onClick={(e) => {
                    e.preventDefault()
                    if (onPageChange != null) {
                        onPageChange(0)
                    }
                }}>
                    <i className="previous"/>
                    <i className="previous"/>
                </button>
            </li>
            <li className={`page-item previous ${prevButtonDisabled ? 'disabled' : ''}`}>
                <button className="page-link" onClick={(e) => {
                    e.preventDefault()
                    prevButtonClick()
                }}>
                    <i className="previous"/>
                </button>
            </li>
            {buttons}
            <li className={`page-item next ${nextButtonDisabled ? 'disabled' : ''}`}>
                <button className="page-link" onClick={(e) => {
                    e.preventDefault()
                    nextButtonClick()
                }}>
                    <i className="next"/>
                </button>
            </li>
            <li className={`page-item next ${nextButtonDisabled ? 'disabled' : ''}`}>
                <button className="page-link" onClick={(e) => {
                    e.preventDefault()
                    if (onPageChange != null) {
                        onPageChange(totalPages-1)
                    }
                }}>
                    <i className="next"/>
                    <i className="next"/>
                </button>
            </li>
        </ul>
    )
}